import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import Backbone from 'backbone';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import {
  Button,
} from '@bingads-webui-react/primitive';

import { CrudAudienceAdReactWithContext } from '../crud-audience-ad-react-with-context';
import { ResponsiveAdRepository } from '../responsive-ad-repository';
import GenericImage from '../../media/1.91to1.jpg';
import { mergeI18n } from '../utils/merge-i18n';

export class StyledMMABulkConversionView extends Backbone.View {
  initialize(props = {}) {
    this.props = props;
    this.state = {};
    this.hasRSAorExTA = props.hasRSAorExTA;
    this.selectedItems = props.selectedItems;
    this.selectedRowCount = props.selectedRowCount;
    this.isPlaceholderMMA = props.isPlaceholderMMA || false;
    this.perfMarker = props.perfMarker;
    this.perfMarker.willInit();
    this.wizardElement = props.wizardElement;
    this.viewContext = props.viewContext || {};
    this.pageContext = _.get(props.deps, 'pageContext') || props.pageContext;
    this.isGridDisplay = props.isGridDisplay;
    this.ad = props.ad;
    this.newI18n = props.newI18n;
    this.i18n = props.i18n;
    this.i18nErrors = DependencyResolver.get('component/api-errors-campaign/index');
    mergeI18n(this.i18n, this.newI18n);

    if (_.isFunction(this.i18nErrors.getI18n)) {
      const i18nInstance = this.i18nErrors.getI18n();
      mergeI18n(this.i18n, i18nInstance ? i18nInstance.realI18n : i18nInstance);
    }

    this.scenario = props.scenario;
    const logScenario = props.instrumentation.bulkEditMMAConversionAd.create();
    this.activityLogger = logScenario.bulkEditMMAConversionAd.create();
    this.hasWebsiteImageOptedInObservable = props.hasWebsiteImageOptedInObservable;
    this.parsedTextMaxLengthExtension = props.parsedTextMaxLengthExtension;
    this.isRecommendation = props.isRecommendation;
    this.jsdata = props.jsdata;
    this.serverContext = props.serverContext;

    this.responsiveAdRepository = new ResponsiveAdRepository({
      viewContext: this.viewContext,
      isVideo: props.isVideo,
      campaignDomain: props.campaignDomain,
    });
    this.crudReactComponent = React.createRef();
    this.onAdSaved = this.onAdSaved.bind(this);
    this.onClose = this.onClose.bind(this);

    const config = DependencyResolver.get('component/config/index');
    const odataToken = config.get('odata.token');
    const odataPath = config.get('odata.url') + config.get('odata.path');
    const odataRootUrl = config.get('CampaignAzureDomain');
    this.permissions = config.get('Permissions');

    this.isOpenCreatePanel = props.isOpenCreatePanel;
    this.isLastStep = props.lastStep === 'ResponsiveAdEditor';
    this.applyActivity = props.applyActivity;

    this.oDataConfig = {
      odataRootUrl,
      odataPath,
      odataToken,
    };
  }
  get pageTitle() {
    return {
      text: this.newI18n.getString(_TL_('MMA_Conversion_From_RSA_PageTitle')),
    };
  }
  onAdSaved() {
    this.trigger('saveAndRefresh');
  }
  onClose() {
    this.trigger('close');
  }

  renderMMABulkConversionActionButtons({ saveMMABulkConversion, cancelMMABulkConversion, isUnSaved }) {
    return (
      <div className="ad-edit-action-buttons" style={{ marginTop: 20, marginBottom: 20 }}>
        {!isUnSaved &&
        <Button
          btnStyle="primary"
          className="save-mma-bulk-conversion-button"
          onClick={saveMMABulkConversion}
        >
          {this.i18n.getString('Audience_Campaign_Ad_Save')}
        </Button>
        }
        <Button
          btnStyle="default"
          className="cancel-mma-bulk-conversion-button"
          onClick={cancelMMABulkConversion}
        >
          {this.i18n.getString('Audience_Campaign_Cancel_Label')}
        </Button>
      </div>
    );
  }

  renderMMABulkConversionHeader({ selectedRowCount }) {
    return (
      <div className="panel-heading" role="heading" aria-level="2">
        <div className="panel-title" data-bind="text: bulkConversionTitle">{this.i18n.getString('Multimedia_Ad_Bulk_Conversion_Title', { count: selectedRowCount })}</div>
        <div className="description" style={{ fontWeight: 'normal' }}>{this.newI18n.getString(_TL_('Your existing responsive search ads will continue to serve after you copy them to Multimedia ads.'))}</div>
      </div>
    );
  }

  renderImageExperience() {
    const {
      customerId, accountId, adGroupId, campaignId, campaignType,
    }= this.props.scope;
    const { instrumentation, allPages } = this.props;
    const config = DependencyResolver.get('component/config/index');
    const odata = DependencyResolver.get('component/http/channel/odata');
    const odataToken = config.get('odata.token');
    const odataPath = config.get('odata.url') + config.get('odata.path');
    const odataRootUrl = config.get('CampaignAzureDomain');
    const jsdata = DependencyResolver.get('component/js-data-campaign/index');
    const viewContext= {
      currentAdGroup: {
        get Id() {
          return adGroupId;
        },
      },
      currentCampaign: {
        Id: campaignId,
        CampaignType: campaignType,
      },
    };
    const preferencesService = DependencyResolver.get('component/preference/service/index');
    const filterService = this.props.filterService.getCombinedFilter();
    this.oDataConfig = {
      odataRootUrl,
      odataPath,
      odataToken,
    };
    return (
      <div className="crud-audience-ad">
        <div className="react-image-experience">
          <CrudAudienceAdReactWithContext
            isForVNext
            isBulkEditMMA
            isMultimediaAd
            isLogoEnabled
            isAdCreatorEnabled
            isStockPhotoEnabled
            ref={this.crudReactComponent}
            responsiveAdRepository={this.responsiveAdRepository}
            odata={odata}
            cid={customerId}
            aid={accountId}
            i18n={this.i18n}
            i18nErrors={this.i18nErrors}
            genericImage={GenericImage}
            viewContext={viewContext}
            pageContext={this.pageContext}
            onAdSaved={this.onAdSaved}
            onClose={this.onClose}
            perfMarker={this.perfMarker.createChild('ReactComp')}
            oDataConfig={this.oDataConfig}
            activityLogger={this.activityLogger}
            permissions={this.permissions}
            instrumentation={instrumentation}
            preferencesService={preferencesService}
            newI18n={this.newI18n}
            isRecommendation={this.isRecommendation}
            jsdata={jsdata}
            selectedItems={this.selectedItems}
            allPages={allPages}
            selectedRowCount={this.selectedRowCount}
            filterService={filterService}
            renderMMABulkConversionHeader={this.renderMMABulkConversionHeader}
            renderMMABulkConversionActionButtons={this.renderMMABulkConversionActionButtons}
            serverContext={this.serverContext}
          />
        </div>
      </div>
    );
  }
  render() {
    ReactDOM.render(
      (
        <div className="panel">{this.renderImageExperience()}</div>
      ), this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

